import htmlTemplate from 'ngeo/drawing/drawFeatureComponent.html';

export default `<div class="alert alert-info">Trop de dessins peuvent rendre
  le lien de partage trop long et empêcher son bon fonctionnement.
  <a href="/help/34-mesure-dessin">En savoir plus</a>
</div>${htmlTemplate}`;
